<div class="tasks-reviewed-by-colleague-details">
  @if (detailsData(); as data) {
    <div class="summary-row">
      <div class="summary-chip" matTooltip="Tiempo que cumple la regla de revisión por compañero." matTooltipPosition="above">
        <span class="summary-chip-label">Aplicable</span>
        <span class="summary-chip-value">{{ data.applicable_registered_seconds | SecondsToHourString }}</span>
      </div>
      <div class="summary-chip" matTooltip="Tiempo total registrado en tareas con presupuesto completado." matTooltipPosition="above">
        <span class="summary-chip-label">Total</span>
        <span class="summary-chip-value">{{ data.total_registered_seconds | SecondsToHourString }}</span>
      </div>
      <div
        class="summary-chip"
        matTooltip="Tareas con presupuesto completado y tiempo registrado en el periodo."
        matTooltipPosition="above"
      >
        <span class="summary-chip-label">Tareas</span>
        <span class="summary-chip-value">{{ data.tasks_evaluated_count }}</span>
      </div>
    </div>

    <div class="ratio-bar" [attr.aria-label]="data.tooltip_summary">
      <div
        class="ratio-bar-segment ratio-bar-segment--applicable"
        [style.width.%]="complianceBarWidth()"
        [matTooltip]="applicableSegmentTooltip()"
        matTooltipClass="kpi-tooltip"
        matTooltipPosition="above"
      >
        @if (complianceBarWidth() >= 10) {
          <span class="ratio-bar-label">{{ complianceBarWidth() | number: '1.0-1' }}%</span>
        }
      </div>
      @if (penalizedBarWidth() > 0) {
        <div
          class="ratio-bar-segment ratio-bar-segment--penalized"
          [style.width.%]="penalizedBarWidth()"
          [matTooltip]="penalizedSegmentTooltip()"
          matTooltipClass="kpi-tooltip"
          matTooltipPosition="above"
        >
          @if (penalizedBarWidth() >= 10) {
            <span class="ratio-bar-label">{{ penalizedBarWidth() | number: '1.0-1' }}%</span>
          }
        </div>
      }
    </div>

    <div class="ratio-legend">
      <span class="legend-item"><span class="legend-dot legend-dot--applicable"></span>Revisadas por compañeros</span>
      <span class="legend-item legend-item--penalized" matTooltipClass="kpi-tooltip" matTooltipPosition="above">
        <span class="legend-dot legend-dot--penalized"></span>Autorevisadas
      </span>
    </div>
  } @else {
    <p class="no-data">No hay tareas con presupuesto completado y tiempo registrado en este periodo.</p>
  }
</div>
